module.exports = __webpack_public_path__ + "static/profil-165_optimized-6c9daa265709d070f8af8a3ec16af22c.jpg";